const CHATBOX_DEBUG_STORAGE_KEY = "chatbox-widget-debug";
const CHATBOX_DEBUG_QUERY_KEYS = ["debug", "chatboxDebug"];

function isDebugEnvEnabled(): boolean {
  try {
    return (
      typeof process !== "undefined" &&
      (process.env.NEXT_PUBLIC_CHATBOX_DEBUG === "1" ||
        process.env.NEXT_PUBLIC_CHATBOX_DEBUG === "true")
    );
  } catch {
    return false;
  }
}

export function isChatboxDebugEnabled(): boolean {
  if (typeof window === "undefined") return false;

  try {
    if (isDebugEnvEnabled()) {
      return true;
    }

    const searchParams = new URLSearchParams(window.location.search);
    for (const key of CHATBOX_DEBUG_QUERY_KEYS) {
      const value = searchParams.get(key)?.toLowerCase();
      if (value === "1" || value === "true") {
        return true;
      }
    }

    if (window.localStorage.getItem(CHATBOX_DEBUG_STORAGE_KEY) === "1") {
      return true;
    }

    const hostname = window.location.hostname;
    return hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1";
  } catch {
    return false;
  }
}

export function chatboxDebugLog(label: string, payload?: unknown): void {
  if (!isChatboxDebugEnabled()) return;

  if (typeof payload === "undefined") {
    console.debug("[ChatboxWidget][debug]", label);
    return;
  }

  console.debug("[ChatboxWidget][debug]", label, payload);
}

export function persistChatboxDebug(enabled: boolean): void {
  if (typeof window === "undefined") return;

  try {
    if (enabled) {
      window.localStorage.setItem(CHATBOX_DEBUG_STORAGE_KEY, "1");
      return;
    }

    window.localStorage.removeItem(CHATBOX_DEBUG_STORAGE_KEY);
  } catch {
    // ignore storage access issues
  }
}
